(function () {
  var popup = document.querySelector('[data-novo-email-popup]');
  var tab = document.querySelector('[data-novo-email-tab]');
  var form = popup && popup.querySelector('[data-novo-email-form]');
  if (!popup || !tab || !form) return;

  var suppressionKey = 'novo-email-popup:suppressed';
  var shoppingFor = '';
  var eligible = false;
  var timer = null;
  var due = false;
  var startedAt = Date.now();
  var week = 7 * 24 * 60 * 60 * 1000;
  var finderObserver = null;

  function finderOpen() {
    var overlay = document.getElementById('novo-car-finder-overlay');
    return Boolean(overlay && overlay.classList.contains('is-open'));
  }

  function context() {
    var finder = window.novoNavCarFinder;
    if (!finder) return null;
    var data = finder.getStoredData();
    var resolved = finder.resolveStoredData(data);
    return resolved && finder.routeMatchesStored(data) ? {data: data, resolved: resolved} : null;
  }

  function suppressed() {
    try { return Date.now() - Number(localStorage.getItem(suppressionKey) || 0) < week; }
    catch (error) { return false; }
  }

  function eventData(reason) {
    return {
      reason: reason || null,
      productHandle: popup.dataset.productHandle || null,
      vehicleLabel: popup.dataset.vehicleLabel || null,
      shoppingFor: shoppingFor || null,
      step: popup.querySelector('[data-email-step="2"]').hidden ? 1 : 2,
      secondsOpen: Math.max(0, Math.round((Date.now() - startedAt) / 1000))
    };
  }

  function log(type, reason) {
    if (window.novoNavSessionApi && window.novoNavSessionApi.logEvent) {
      window.novoNavSessionApi.logEvent(type, eventData(reason));
    }
  }

  function openPopup(manual) {
    if (finderOpen()) return;
    if (manual && !context()) {
      if (window.openCarFinderPopup) window.openCarFinderPopup(true);
      return;
    }
    if (!manual && (!eligible || suppressed())) {
      tab.hidden = finderOpen();
      return;
    }
    popup.hidden = false;
    tab.hidden = true;
    startedAt = Date.now();
  }

  function hidePopup(save, reason) {
    var wasOpen = !popup.hidden;
    popup.hidden = true;
    tab.hidden = finderOpen();
    if (!save) return;
    try { localStorage.setItem(suppressionKey, String(Date.now())); } catch (error) {}
    if (wasOpen) log('email-popup-dismissed', reason);
  }

  function arm() {
    eligible = Boolean(context());
    clearTimeout(timer);
    timer = null;
    due = false;
    if (!eligible) {
      tab.hidden = finderOpen();
      return;
    }
    tab.hidden = finderOpen();
    if (finderOpen()) return;
    timer = setTimeout(function () {
      timer = null;
      due = true;
      openPopup(false);
    }, 6000);
  }

  function refresh() {
    if (!context()) {
      eligible = false;
      due = false;
      clearTimeout(timer);
      timer = null;
      popup.hidden = true;
      tab.hidden = finderOpen();
      return;
    }
    if (finderOpen()) {
      eligible = true;
      due = false;
      clearTimeout(timer);
      timer = null;
      popup.hidden = true;
      tab.hidden = true;
      return;
    }
    if (!eligible || (!timer && !due && popup.hidden)) arm();
    else tab.hidden = !popup.hidden;
    if (due) openPopup(false);
  }

  function observeFinder() {
    var overlay = document.getElementById('novo-car-finder-overlay');
    if (!overlay || finderObserver) return;
    finderObserver = new MutationObserver(refresh);
    finderObserver.observe(overlay, {attributes: true, attributeFilter: ['class']});
  }

  popup.querySelector('[data-novo-email-close]').addEventListener('click', function () {
    hidePopup(true, 'close-button');
  });
  popup.querySelector('[data-novo-email-decline]').addEventListener('click', function () {
    hidePopup(true, 'no-thanks');
  });
  popup.addEventListener('click', function (event) {
    if (event.target === popup) hidePopup(true, 'backdrop');
  });
  tab.addEventListener('click', function () {
    openPopup(true);
  });
  popup.querySelectorAll('[data-choice]').forEach(function (button) {
    button.addEventListener('click', function () {
      shoppingFor = button.dataset.choice;
      popup.querySelector('[data-email-step="1"]').hidden = true;
      popup.querySelector('[data-email-step="2"]').hidden = false;
      form.email.focus();
    });
  });
  document.addEventListener('mouseout', function (event) {
    if (event.clientY <= 0 && !event.relatedTarget && matchMedia('(pointer:fine)').matches) openPopup(false);
  });
  window.addEventListener('novoNavFinderUpdated', function () {
    setTimeout(function () { observeFinder(); refresh(); }, 0);
  });
  window.addEventListener('novoNavCarFinderReady', function () {
    observeFinder();
    refresh();
  });
  window.addEventListener('novo-nav-session-order-linked', function () {
    if (!popup.hidden) hidePopup(false);
  });

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    var status = form.querySelector('[data-novo-email-status]');
    var button = form.querySelector('button[type=submit]');
    if (!context()) return;
    if (!window.novoNavSessionApi) {
      status.textContent = 'Please refresh the page and try again.';
      return;
    }
    button.disabled = true;
    status.textContent = 'Sending…';
    window.novoNavSessionApi.request('marketing-signup', {
      email: form.email.value,
      company: form.company.value,
      formStartedAt: startedAt,
      pageUrl: location.href,
      pageTitle: popup.dataset.pageTitle,
      productHandle: popup.dataset.productHandle,
      shoppingFor: shoppingFor,
      vehicleLabel: popup.dataset.vehicleLabel,
      shorthandName: popup.dataset.shorthandName,
      superShortName: popup.dataset.superShortName,
      consentVersion: 'popup-personalised-ads-v1'
    }).then(function (result) {
      var data = new FormData();
      data.append('form_type', 'customer');
      data.append('utf8', '✓');
      data.append('contact[email]', form.email.value);
      data.append('contact[tags]', 'newsletter,novo-nav-popup');
      fetch('/contact', {method: 'POST', body: data, credentials: 'same-origin'}).catch(function () {});
      status.textContent = result.verificationRequired
        ? 'Check your inbox to confirm your address.'
        : 'Done — your dash cam offer is in your inbox.';
      try { localStorage.setItem(suppressionKey, String(Date.now())); } catch (error) {}
      setTimeout(function () { hidePopup(false); }, 2200);
    }).catch(function (error) {
      status.textContent = error.message || 'Something went wrong. Please try again.';
      button.disabled = false;
    });
  });

  observeFinder();
  refresh();
})();
